import React, { createContext, useContext, useMemo, useState } from 'react';

interface ProgressContextType {
  progress: number;
  setProgress: React.Dispatch<React.SetStateAction<number>>;
}

const ProgressContext = createContext<ProgressContextType>({
  progress: 0,
  setProgress: () => {},
});

const ProgressProvider: React.FC = ({ children }) => {
  const [progress, setProgress] = useState(0);

  const value = useMemo(
    () => ({ progress, setProgress }),
    [progress, setProgress]
  );

  return (
    <ProgressContext.Provider value={value}>
      {children}
    </ProgressContext.Provider>
  );
};

const useProgress = (): ProgressContextType => useContext(ProgressContext);

export { ProgressProvider, useProgress };
